import CoreThemeProvider, { Theme } from '@nexus/lib-react/dist/theme/CoreTheme/CoreThemeProvider';

const { theme } = CoreThemeProvider.defaultProps;

type SemanticColors = Theme['colors'] & {
  primary: string;
  secondary: string;
  tertiary: string;
  linkPrimary: string;
  primaryInverted: string;
  bgPrimary: string;
  bgInfo: string;
  bgSecondary: string;
  error: string;
  bgError: string;
  bgSuccess: string;
};

type SemanticFonts = Theme['fonts'] & {
  primary: string;
};

type SemanticSizes = Theme['sizes'] & {
  '2xs': string;
  xs: string;
  s: string;
  regular: string;
  m: string;
  semiLarge: string;
  l: string;
  xl: string;
  '2xl': string;
  '3xl': string;
  '4xl': string;
  '5xl': string;
  '6xl': string;
};

type SemanticFontWeights = Theme['fontWeights'] & {
  normal: string;
  medium: string;
};

type SemanticRadii = Theme['radii'] & {
  primary: string;
};

export interface WrappedTheme extends Theme {
  colors: SemanticColors;
  fonts: SemanticFonts;
  sizes: SemanticSizes;
  fontWeights: SemanticFontWeights;
  radii: SemanticRadii;
}

export default {
  ...theme,
  fonts: {
    primary: theme.fonts.Geomanist,
  },
  colors: {
    ...theme.colors,
    primary: theme.colors.charcoal,
    secondary: theme.colors.grey5,
    tertiary: theme.colors.grey4,
    linkPrimary: theme.colors.bluePrimary,
    primaryInverted: theme.colors.white,
    bgPrimary: theme.colors.white,
    bgInfo: theme.colors.yellowTintLight,
    bgSecondary: theme.colors.grey2,
    error: theme.colors.redPrimary,
    bgError: theme.colors.redLight,
    bgSuccess: theme.colors.tealBgLight,
  },
  sizes: {
    ...theme.sizes,
    '2xs': '2px',
    xs: '4px',
    s: '8px',
    regular: '12px',
    m: '14px',
    semiLarge: '16px',
    l: '18px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '48px',
    '4xl': '54px',
    '5xl': '64px',
    '6xl': '72px',
  },
  fontWeights: {
    ...theme.fontWeights,
    normal: theme.fontWeights[400],
    medium: theme.fontWeights[500],
  },
  radii: {
    ...theme.radii,
    primary: theme.radii['4'],
  },
} as unknown as WrappedTheme;
